import {Injectable} from "@angular/core";
import {TranslateService} from '@ngx-translate/core';

import nb from "@angular/common/locales/nb";
import nn from "@angular/common/locales/nn";

import {registerLocaleData} from "@angular/common";
import {isEmpty} from "radash";


/**
 * Tjeneste som sørger for å laste oversettelser inn i ngx-translate.
 * Se https://github.com/ngx-translate/core
 *
 * Benytt tjenesten {@link Oversettelser} for tilgang til selve oversettelsene.
 */
@Injectable()
export class OversettelserRegister {

    private oversettelserLastet = false;

    constructor(private readonly translate: TranslateService) {
    }

    /**
     * Laster språkfiler (po) med oversettelser og konfigurerer lokalisering (oversettelser, formater osv.) knyttet til angular sine pipes.
     */
    public lastOversettelser() {
        if (this.oversettelserLastet) return;

        let poFiler = this.poFilerSomJson();

        this.translate.setTranslation("nb", poFiler.norsk);
        this.translate.setTranslation("nn", poFiler.nynorsk);
        this.translate.setTranslation("en", poFiler.engelsk);

        // laster angular sine lokaliseringsdata for bokmål, nynorsk
        // 'en-US' er standard locale, men må ev. støtte andre lokale variasjoner senere.
        registerLocaleData(nb)
        registerLocaleData(nn)
    }

    //hjelpemetoder

    /**
     * Returnerer oversettelser fra po-filer transformert til JSON
     */
    private poFilerSomJson(): POSomJSON {
        let norsk = require('./../../../../i18n/web-ng2/nb.po');
        let nynorsk = require('./../../../../i18n/web-ng2/nn.po');
        let engelsk = require('./../../../../i18n/web-ng2/en.po');

        return {
            norsk: this.transformerOversettelser(norsk.translations[""]),
            nynorsk: this.transformerOversettelser(nynorsk.translations[""]),
            engelsk: this.transformerOversettelser(engelsk.translations[""])
        }
    }

    /**
     * Går gjennom JSON-objekt med oversettelser fra webpack og transformerer det til forventet json-struktur i ngx-translate
     * Basis-strukturen som forventes er {nøkkel:string, verdi:string } der verdi kan inneholde {{parameternavn}} som ngx-translate vil interpolere
     * @param oversettelser oversettelser fra transformert po-fil
     * @private
     */
    private transformerOversettelser(oversettelser: any): NgxOversettelse {
        return Object.keys(oversettelser)
          .reduce((resultat, nøkkel) => {
              // Akkumlerer nøkkel/verdi-par inn i resultat
              if (isEmpty(nøkkel)) return resultat;

              const translation: string = oversettelser[nøkkel].msgstr.pop();

              if (nøkkel.length > 0 && !isEmpty(translation)) {
                  resultat[nøkkel] = translation;
              }

              return resultat;
          }, {} as NgxOversettelse);
    }

}

export interface NgxOversettelse {
    [nøkkel: string]: string
}

interface POSomJSON {
    norsk: Readonly<NgxOversettelse>,
    nynorsk: Readonly<NgxOversettelse>,
    engelsk: Readonly<NgxOversettelse>
}
